import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center" };
const _hoisted_2 = {
    class: "relative w-full mx-4 bg-white shadow-xl rounded-2xl",
    style: { "max-width": "440px" }
};
const _hoisted_3 = {
    class: "flex items-center h-16 gap-3 px-6 border-b",
    style: { "border-color": "#fee2e2" }
};
const _hoisted_4 = { class: "flex-1 text-base font-bold text-gray-900" };
const _hoisted_5 = { class: "px-6 py-6" };
const _hoisted_6 = {
    class: "flex items-start gap-3 p-4 border rounded-xl",
    style: { "background-color": "#fef2f2", "border-color": "#fecaca" }
};
const _hoisted_7 = { class: "text-sm text-gray-700" };
const _hoisted_8 = { class: "flex items-center justify-end gap-3 px-6 pb-6" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    key: 0,
    class: "w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"
};
import { IconAlertTriangle, IconX, IconInfoCircle, IconCircleX, } from "@tabler/icons-vue";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CloseConversationModal',
    props: {
        isLoading: { type: Boolean }
    },
    emits: ["confirm", "cancel"],
    setup(__props) {
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(IconAlertTriangle), { class: "flex-shrink-0 w-5 h-5 text-red-400" }),
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("conversation.close_modal.title")), 1),
                            _createElementVNode("button", {
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('cancel'))),
                                class: "p-1 text-gray-400 rounded-lg hover:bg-gray-100"
                            }, [
                                _createVNode(_unref(IconX), { class: "w-5 h-5" })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(IconInfoCircle), { class: "w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" }),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("conversation.close_modal.body")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('cancel'))),
                                class: "px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-50"
                            }, _toDisplayString(_unref(t)("common.actions.cancel")), 1),
                            _createElementVNode("button", {
                                disabled: __props.isLoading,
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('confirm'))),
                                class: "flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-xl hover:bg-red-700 disabled:opacity-50"
                            }, [
                                (__props.isLoading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                                    : (_openBlock(), _createBlock(_unref(IconCircleX), {
                                        key: 1,
                                        class: "w-4 h-4"
                                    })),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("conversation.actions.close_conversation")), 1)
                            ], 8, _hoisted_9)
                        ])
                    ])
                ])
            ]));
        };
    }
});
